import React from 'react';
import { cn } from '../../lib/utils';

export const Alert = React.forwardRef(({ className, variant = 'default', children, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(
      'relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7',
      {
        'bg-background text-foreground': variant === 'default',
        'border-accent/35 bg-accent/10 text-foreground': variant === 'info',
        'border-destructive/40 bg-destructive/10 text-destructive': variant === 'destructive',
      },
      className
    )}
    {...props}
  >
    {children}
  </div>
));
Alert.displayName = 'Alert';

export const AlertTitle = React.forwardRef(({ className, children, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn('mb-1 font-medium leading-none tracking-tight', className)}
    {...props}
  >
    {children}
  </h5>
));
AlertTitle.displayName = 'AlertTitle';

export const AlertDescription = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('text-sm [&_p]:leading-relaxed', className)}
    {...props}
  >
    {children}
  </div>
));
AlertDescription.displayName = 'AlertDescription';
